const Divider = ({ text }: { text: string }) => {
  return (
    <div className="flex items-center">
      <hr className="flex-grow border-t border-gray-300" />
      {text && <span className="px-3 text-gray-500 text-sm">{text}</span>}
      <hr className="flex-grow border-t border-gray-300" />
    </div>
  );
};

export default Divider;
